"use client";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from "@/components/ui/dialog";
import { useToast } from "@/hooks/use-toast";
import { deleteTalentProfile } from "@/lib/supabase";

export interface DeleteUserDialogProps {
  open: boolean;
  onClose: () => void;
  userId: string;
  userName: string;
  onDeleted?: () => void;
}

export function DeleteUserDialog({
  open,
  onClose,
  userId,
  userName,
  onDeleted
}: DeleteUserDialogProps) {
  const { toast } = useToast();

  const handleConfirm = async () => {
    try {
      await deleteTalentProfile(userId);
      toast({ title: "Erfolg", description: "Benutzer wurde gelöscht." });
      onClose();
      onDeleted?.();
    } catch (error) {
      console.error("Error deleting user:", error);
      toast({
        title: "Fehler",
        description: "Benutzer konnte nicht gelöscht werden.",
        variant: "destructive"
      });
    }
  };

  return (
    <Dialog
      open={open}
      onOpenChange={(v) => {
        if (!v) onClose();
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Benutzer löschen</DialogTitle>
          <DialogDescription>
            Sind Sie sicher, dass Sie "{userName}" löschen möchten? Diese Aktion
            kann nicht rückgängig gemacht werden.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Abbrechen
          </Button>
          <Button variant="destructive" onClick={handleConfirm}>
            Löschen
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
